export enum AsperaTransferDirection {
  all = "all",
  send = "send",
  receive = "receive",
  unknown = "unknown",
}
